__turbopack_context__.v({
  "alt": "rkE2ka_alt",
  "checkbox-container": "rkE2ka_checkbox-container",
  "checkmark": "rkE2ka_checkmark",
  "disabled": "rkE2ka_disabled",
  "error": "rkE2ka_error",
  "label": "rkE2ka_label",
  "light": "rkE2ka_light",
});
